import * as React from 'react';
import Compose from './Compose';
import ComposeCommandingBar from './ComposeCommandingBar';
import { findComposePlugins } from 'owa-mail-compose-store/lib/plugins/ComposePlugins';
import FloatingViewState from 'owa-mail-compose-store/lib/store/schema/FloatingViewState';
import Dock from './Dock';
import { InitialActions, createInitialActions, executeInitialActions } from 'owa-initial-actions';
import floatCompose from 'owa-mail-compose-store/lib/actions/floatCompose';
import setAsyncSendState from 'owa-mail-compose-store/lib/actions/setAsyncSendState';
import strings from 'owa-strings/owa-mail-strings';
import { AsyncSendState } from 'owa-mail-compose-store/lib/store/schema/ComposeViewState';
import { FloatingType } from 'owa-mail-compose-store/lib/store/schema/FloatingViewState';
import { getStore } from 'owa-mail-compose-store/lib/store/composeStore';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { observer } from 'mobx-react';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./FloatingCompose.scss');
const classNames = require('classnames/bind').bind(styles);

export interface FloatingComposeProps {
    viewState: FloatingViewState;
}

@observer
export default class FloatingCompose extends React.Component<FloatingComposeProps, {}> {
    initialActions: InitialActions;

    constructor(props: FloatingComposeProps) {
        super(props);
        this.initialActions = createInitialActions();
    }

    componentDidMount() {
        executeInitialActions(this.initialActions);
    }

    render() {
        const { type, composeId } = this.props.viewState;
        const composeStore = getStore();
        const composeViewState = composeStore.viewStates.get(composeId);
        let outerContainerClasses = '';
        const composePlugins = findComposePlugins(composeViewState);
        const scrollAdapter = composePlugins && composePlugins.dockingPlugin.getScrollAdapter();

        switch (type) {
            case FloatingType.Normal:
                outerContainerClasses = styles.floating;
                break;
            case FloatingType.Minimized:
                outerContainerClasses = classNames(styles.floating, styles.minimized);
                break;
            case FloatingType.Maximized:
                outerContainerClasses = classNames(styles.floating, styles.maximized);
                break;
        }
        return type == FloatingType.Minimized ? (
            <div className={outerContainerClasses}>{this.renderMinimizedComposeTitle()}</div>
        ) : (
            <div className={outerContainerClasses}>
                <ComposeCommandingBar
                    composeViewState={composeViewState}
                    isFloatingCompose={true}
                />
                <div className={styles.floatingBody}>
                    <Compose
                        viewState={composeViewState}
                        className={classNames(styles.scrollContainer, 'customScrollBar')}
                        initialActions={this.initialActions}
                        ref={ref =>
                            scrollAdapter &&
                            scrollAdapter.setScrollContainer(ref ? ref.getRootDiv() : null)
                        }
                    />
                    <Dock viewState={composeViewState} initialActions={this.initialActions} />
                </div>
            </div>
        );
    }

    private renderMinimizedComposeTitle() {
        const composeStore = getStore();
        const { asyncSendState } = composeStore.viewStates.get(this.props.viewState.composeId);
        switch (asyncSendState) {
            case AsyncSendState.Timeout:
                return (
                    <div onClick={this.onClickMinimizedTitle} className={styles.titleButtonBar}>
                        <Spinner className={styles.toastSpinner} />
                        {strings.messageIsSendingTitle}
                    </div>
                );

            case AsyncSendState.Error:
                return (
                    <div
                        onClick={this.onClickMinimizedTitle}
                        className={classNames(styles.titleButtonBar, styles.error)}>
                        <Icon iconName={ControlIcons.Error} className={styles.toastIcon} />
                        {strings.messageSendingFailTitle}
                    </div>
                );

            case AsyncSendState.Sent:
                return (
                    <div onClick={this.onClickMinimizedTitle} className={styles.titleButtonBar}>
                        <Icon iconName={ControlIcons.CheckMark} className={styles.toastIcon} />
                        {strings.messageIsSentTitle}
                    </div>
                );

            default:
                return null;
        }
    }

    private onClickMinimizedTitle = () => {
        const composeStore = getStore();
        const { composeId } = this.props.viewState;
        const composeViewState = composeStore.viewStates.get(composeId);
        if (composeViewState.asyncSendState == AsyncSendState.Sent) {
            setAsyncSendState(composeViewState, AsyncSendState.Closed);
        } else {
            floatCompose(composeViewState, FloatingType.Normal);
        }
    };
}
